import { useParams } from "react-router-dom";
import { Grid } from "antd";
import { useGetUserFlightDetailsQuery } from "src/store/slices/client/client.api";
import { withConditionalComponent } from "src/HOC/WithMobileComponent";
import { MOBILE_BREAKPOINT_KEY } from "src/constants";
import TravelTransactionDetailsWeb from "./layouts/TravelTransactionDetails.web";
import TravelTransactionDetailsMob from "./layouts/TravelTransactionDetails.mob";
import TravelTransactionDetailsSkeleton from "./components/TravelTransactionDetailsSkeleton/TravelTransactionDetailsSkeleton";
import NoData from "@Components/NoData/NoData";
import { useTranslation } from "react-i18next";

const TravelTransactionDetailsLayout = withConditionalComponent(TravelTransactionDetailsWeb, TravelTransactionDetailsMob);

export default function TravelTransactionDetails() {
  const { id } = useParams();
  const { data, isFetching, error } = useGetUserFlightDetailsQuery({ referenceNumber: id });
  const { t } = useTranslation();
  const isLargeScreen = !!Grid.useBreakpoint()[MOBILE_BREAKPOINT_KEY];


  if (isFetching) {
    return (
      <div className="flex w-full flex-1 items-start justify-center md:p-5">
        <TravelTransactionDetailsSkeleton />
      </div>
    );
  }
  if (!isFetching && error) {
    return (
      <div className="flex w-full flex-1 items-center justify-center">
        <NoData description={t("UserHistory.orderDetails.detailsUnavailable")} className="h-full w-full" />
      </div>
    );
  }

  return (
    <div className="flex w-full flex-1 items-start justify-center md:p-5">
      <TravelTransactionDetailsLayout
        trigger={isLargeScreen}
        props={{ data }}
      />
    </div>
  );
}
